module.exports = __webpack_public_path__ + "img/sequence-suidobashi.c2068a25.jpg";